// returns true for all au/nz trusts
export const trustDeedRequired = (
  registeredCountry = "",
  businessType = ""
): boolean =>
  (registeredCountry === "New Zealand" || registeredCountry === "Australia") &&
  businessType === "Trust";
